import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  FunctionField,
  ReferenceField,
} from 'react-admin';
import { Box } from '@mui/material';
import { TableChart as TableIcon } from '@mui/icons-material';

const DevicesEdit = (props: any) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source='variableName' required />
      <TextInput source='deviceId' required />
      <SelectInput
        source='deviceType'
        label='Tipo de Dispositivo'
        choices={[
          { id: 'DEVICE', name: 'DEVICE' },
          { id: 'PLC', name: 'PLC' },
        ]}
        required
      />
      <TextInput source='ipAddress' required />
      <ReferenceField
        label='Tabla'
        source='tableId'
        reference='tables'
        link='show'
        emptyText='-'
      >
        <FunctionField
          render={(table: any) => (
            <Box display='flex' alignItems='center' gap={1}>
              <TableIcon fontSize='small' color='action' />
              <span>
                {table?.tableName || table?.name || `Tabla ${table?.id}`}
              </span>
            </Box>
          )}
        />
      </ReferenceField>
    </SimpleForm>
  </Edit>
);

export default DevicesEdit;
